// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ourPartners_div {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: #1d1a36;
  padding: 6vw 0vw;
}
.ourPartners_heading {
  color: #fff;
  font-family: Roboto;
  font-size: 5.1vh;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  padding-bottom: 3.9vw;
}
.ourPartners_card {
  display: flex;
  justify-content: center;
  width: 95vw;
  padding: 4vw 0vw;
  border-radius: 32.25px;
  background: linear-gradient(137deg, rgba(255, 182, 160, 0.2) 0%, rgba(240, 89, 42, 0.2) 18.54%, rgba(37, 60, 119, 0.2) 100%);
}
.ourPartners_col {
  margin: 0vw 2vw;
  width: 100%;
  display: flex;
  align-self: center;
  justify-content: center;
}
.ourPartners_img {
  width: 15vw;
}

@media only screen and (max-width: 601px) {
  .ourPartners_heading {
    padding-bottom: 6vw;
    font-size: 6vw;
  }
  .ourPartners_img {
    width: 50vw;
  }
  .ourPartners_card {
    width: 70vw;
    padding: 10vw;
    border-radius: 10px;
  }
  .ourPartners_div {
    padding: 16vw 0vw 0vw;
  }
}
@media only screen and (min-width: 601px) and (max-width: 721px) {
  .ourPartners_heading {
    font-size: 5vw;
  }
  .ourPartners_img {
    width: 33vw;
  }
  .ourPartners_card {
    width: 80vw;
  }
}
@media only screen and (min-width: 721px) and (max-width: 1026px) {
  .ourPartners_heading {
    font-size: 3.5vw;
  }
  .ourPartners_card {
    padding: 5vw;
    width: 85vw;
  }
  .ourPartners_img {
    width: 23vw;
  }
  .ourPartners_col {
    margin: 0vw 0vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}
@media only screen and (min-width: 1026px) and (max-width: 1388px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_card {
    padding: 5vw 3vw;
    width: 90vw;
  }
  .ourPartners_img {
    width: 15vw;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}
@media only screen and (min-width: 1388px) and (max-width: 1921px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_card {
    padding: 3vw 0vw;
    width: 90vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
  .ourPartners_img {
    width: 16vw;
  }
}
@media only screen and (min-width: 1921px) and (max-width: 2561px) {
  .ourPartners_heading {
    font-size: 5.1vh;
  }
  .ourPartners_col {
    margin: 0vw 1vw;
  }
  .ourPartners_card {
    padding: 3vw 4vw;
    width: 75vw;
  }
  .ourPartners_img {
    width: 18vw;
  }
  .ourPartners_div {
    padding: 7.8vw 0vw 0vw;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/OurPartners/ourPartners.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;AAGE;EACE,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,qBAAA;AADJ;AAIE;EACE,aAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,4HAAA;AAFJ;AASE;EACE,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;AAPJ;AAUE;EACE,WAAA;AARJ;;AAWA;EAEI;IACE,mBAAA;IACA,cAAA;EATJ;EAYE;IACE,WAAA;EAVJ;EAYE;IACE,WAAA;IACA,aAAA;IACA,mBAAA;EAVJ;EAYE;IACE,qBAAA;EAVJ;AACF;AAeA;EAEI;IACE,cAAA;EAdJ;EAiBE;IACE,WAAA;EAfJ;EAkBE;IACE,WAAA;EAhBJ;AACF;AAoBA;EAEI;IACE,gBAAA;EAnBJ;EAsBE;IACE,YAAA;IACA,WAAA;EApBJ;EAuBE;IACE,WAAA;EArBJ;EAuBE;IACE,eAAA;EArBJ;EAuBE;IACE,sBAAA;EArBJ;AACF;AAyBA;EAEI;IACE,gBAAA;EAxBJ;EA2BE;IACE,gBAAA;IACA,WAAA;EAzBJ;EA4BE;IACE,WAAA;EA1BJ;EA4BE;IACE,eAAA;EA1BJ;EA4BE;IACE,sBAAA;EA1BJ;AACF;AA8BA;EAEI;IACE,gBAAA;EA7BJ;EA+BE;IACE,eAAA;EA7BJ;EA+BE;IACE,gBAAA;IACA,WAAA;EA7BJ;EA+BE;IACE,sBAAA;EA7BJ;EA+BE;IACE,WAAA;EA7BJ;AACF;AAgCA;EAEI;IACE,gBAAA;EA/BJ;EAiCE;IACE,eAAA;EA/BJ;EAiCE;IACE,gBAAA;IACA,WAAA;EA/BJ;EAkCE;IACE,WAAA;EAhCJ;EAkCE;IACE,sBAAA;EAhCJ;AACF","sourcesContent":[".ourPartners {\n  &_div {\n    display: flex;\n    justify-content: center;\n    flex-direction: column;\n    align-items: center;\n    width: 100%;\n    background: #1d1a36;\n    padding: 6vw 0vw;\n  }\n\n  &_heading {\n    color: #fff;\n    font-family: Roboto;\n    font-size: 5.1vh;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 100%;\n    padding-bottom: 3.9vw;\n  }\n\n  &_card {\n    display: flex;\n    justify-content: center;\n    width: 95vw;\n    padding: 4vw 0vw;\n    border-radius: 32.25px;\n    background: linear-gradient(\n      137deg,\n      rgba(255, 182, 160, 0.2) 0%,\n      rgba(240, 89, 42, 0.2) 18.54%,\n      rgba(37, 60, 119, 0.2) 100%\n    );\n  }\n  &_col {\n    margin: 0vw 2vw;\n    width: 100%;\n    display: flex;\n    align-self: center;\n    justify-content: center;\n   \n  }\n  &_img {\n    width: 15vw;\n  }\n}\n@media only screen and (max-width: 601px) {\n  .ourPartners {\n    &_heading {\n      padding-bottom: 6vw;\n      font-size: 6vw;\n    }\n\n    &_img {\n      width: 50vw;\n    }\n    &_card {\n      width: 70vw;\n      padding:10vw;\n      border-radius: 10px;\n    }\n    &_div {\n      padding: 16vw 0vw 0vw;\n  \n    }\n  }\n}\n\n@media only screen and (min-width: 601px) and (max-width: 721px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5vw;\n    }\n\n    &_img {\n      width: 33vw;\n    }\n\n    &_card {\n      width: 80vw;\n    }\n  }\n}\n\n@media only screen and (min-width: 721px) and (max-width: 1026px) {\n  .ourPartners {\n    &_heading {\n      font-size: 3.5vw;\n    }\n\n    &_card {\n      padding: 5vw ;\n      width: 85vw;\n    }\n\n    &_img {\n      width: 23vw;\n    }\n    &_col{\n      margin: 0vw 0vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n}\n}\n@media only screen and (min-width: 1026px) and (max-width: 1388px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n\n    &_card {\n      padding: 5vw 3vw;\n      width: 90vw;\n    }\n\n    &_img {\n      width: 15vw;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n  }\n}\n@media only screen and (min-width: 1388px) and (max-width: 1921px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_card {\n      padding: 3vw 0vw;\n      width: 90vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n    }\n    &_img{\n      width: 16vw;\n    }\n  }\n}\n@media only screen and (min-width: 1921px) and (max-width: 2561px) {\n  .ourPartners {\n    &_heading {\n      font-size: 5.1vh;\n    }\n    &_col{\n      margin: 0vw 1vw;\n    }\n    &_card {\n      padding: 3vw 4vw;\n      width: 75vw;\n    }\n\n    &_img {\n      width: 18vw;\n    }\n    &_div {\n      padding: 7.8vw 0vw 0vw;\n  \n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
